<section class="named_card"
  [class.horisontal]="award.named_card.preview?.is_horisontal">
  <span class="named_card__card">
    <span *ngIf="award.count_cards > 1" class="named_card__card__count">
      {{ award.count_cards }}
    </span>
    <span>
      <img src="{{ award.named_card.preview?.url }}" alt="{{ award.named_card.title }}">
    </span>
  </span>
  <span class="named_card__info">
    <span class="named_card__title">
      {{ award.named_card.title }}
    </span>
    <span *ngIf="award.for_what" class="named_card__for_what">
      {{ award.for_what | wordSlice:4 }}
    </span>
    <span class="named_card__date">
      {{ award.date | date }}
    </span>
  </span>
</section>
